import type { DiscoveredRouteModule } from '@/router/generator/types';

const RegisterView = () => import('@/views/RegisterView.vue');
export const NAME_REGISTER = 'Register';

export const route: DiscoveredRouteModule = {
  id: 'root.auth.register',
  scope: 'root',
  name: NAME_REGISTER,
  // Path variation will be normalized by assembler wrapper for white/private
  path: '/register/:projectId?',
  component: RegisterView,
  meta: { requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true, skipRBAC: true, skipLoading: true, dataLoaders: ['project_registration_fields'] },
};


